import { f7, useStore } from 'framework7-react';
import { FC, useEffect, useState } from 'react';
import style from './carAssetValueInputStyle.module.css';
import { fetchAssetValueColorsApi } from '@/api/carApi';
import { PageTemplate } from '@/components/uiParts/Template/PageTemplate/PageTemplate';
import { paths } from '@/config/paths';
import { store } from '@/config/store';
import { Car } from '@/types/api/customerApi';

type ColorOption = { id: number; color_name: string };

export const CarAssetValueInputPage: FC = () => {
  const carItemInfo = useStore(store, 'carItemInfo') as Required<Car>;
  const [mileage, setMileage] = useState('');
  const [colorId, setColorId] = useState('');
  const [colors, setColors] = useState<ColorOption[]>([]);

  // 走行距離の初期値をセット
  useEffect(() => {
    if (carItemInfo?.meter_count) {
      setMileage(String(carItemInfo.meter_count));
    }
  }, [carItemInfo?.meter_count]);

  // 色マスタを取得
  useEffect(() => {
    fetchAssetValueColorsApi()
      .then((res) => {
        if (res.data?.success && res.data.data) {
          setColors(res.data.data);
        }
      })
      .catch(() => {
        // 取得失敗時は空のまま
      });
  }, []);

  const isValid = mileage.trim() !== '' && colorId !== '';

  const handleSubmit = () => {
    if (!isValid || !carItemInfo?.t_stock_car_id) return;

    f7.view.main.router.navigate(paths.carAssetValue, {
      props: {
        overrideMlg: Number(mileage),
        overrideExColId: colorId,
      },
    });
  };

  return (
    <PageTemplate
      pageName="car-asset-value-input"
      title="詳細情報入力"
      showNavBack
    >
      <div className={style['container']}>
        <div className={style['card']}>
          <div className={style['field']}>
            <div className={style['field-label']}>
              <span>走行距離</span>
              <span className={style['required']}>必須</span>
            </div>
            <input
              type="number"
              className={style['field-input']}
              value={mileage}
              onChange={(e) => setMileage(e.target.value)}
              placeholder=""
              inputMode="numeric"
            />
          </div>

          <div className={style['field']}>
            <div className={style['field-label']}>
              <span>色</span>
              <span className={style['required']}>必須</span>
            </div>
            <select
              className={style['field-select']}
              value={colorId}
              onChange={(e) => setColorId(e.target.value)}
            >
              <option value="">選択してください</option>
              {colors.map((c) => (
                <option key={c.id} value={String(c.id)}>
                  {c.color_name}
                </option>
              ))}
            </select>
          </div>

          <button
            type="button"
            className={style['submit-button']}
            disabled={!isValid}
            onClick={handleSubmit}
          >
            査定する
          </button>
        </div>
      </div>
    </PageTemplate>
  );
};
